import { ApolloLink } from './ApolloLink.js';

export const concat = ApolloLink.concat;
